import PropTypes from "prop-types";
import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Kaizen Dashboard base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import dayjs from "dayjs";
import axios from "axios";
import { urlBase } from "services/config";
import DatosEmpresa from "layouts/componentes/datosEmpresa";
import { agregarCeros } from "utils/truncate";

function Header({ factura }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  return (
    <SoftBox>
      <SoftBox display="flex" alignItems="center" borderRadius="xl" />
      <SoftBox
        sx={{
          backdropFilter: `saturate(200%) blur(30px)`,
          backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 1),
          boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
          border: "1px solid",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="flex-start
        "
          px={1}
        >
          <Grid
            item
            xs={6}
            height="100%"
            lineHeight={2}
            display="flex"
            flexDirection="column"
            textAlign="center"
            justifyContent="space-evenly"
            pt={0.5}
          >
            <DatosEmpresa />
            <SoftBox display="flex" justifyContent="space-between">
              <SoftTypography variant="subtitle2" fontWeight="medium">
                Origen: {factura?.sucursal || "-"}
              </SoftTypography>

              <SoftTypography variant="subtitle2" fontWeight="medium">
                Destino: {factura?.sucursal_destino?.name || "-"}
              </SoftTypography>
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox height="100%" mt={0.5} lineHeight={1} textAlign="end">
              <SoftBox>
                <SoftTypography variant="h5" fontWeight="medium">
                  {"Remito N°:" +
                    (factura?.codigoSucursal ? agregarCeros(factura.codigoSucursal, 4) : "") +
                    "-" +
                    (factura.numero ? factura.numero : factura.id)}
                </SoftTypography>
                {factura?.fecha ? (
                  <SoftTypography variant="h5" fontWeight="medium">
                    Fecha: {dayjs(factura?.fecha).format("DD-MM-YYYY")}
                  </SoftTypography>
                ) : factura?.dateAdd ? (
                  <SoftTypography variant="h5" fontWeight="medium">
                    Fecha: {dayjs(factura?.dateAdd).format("DD-MM-YYYY")}
                  </SoftTypography>
                ) : null}
              </SoftBox>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

Header.propTypes = {
  status: PropTypes.number,
  dataPresupuesto: PropTypes.object,
  factura: PropTypes.object,
  id: PropTypes.string,
  tipo: PropTypes.string,
};

export default Header;
